import * as types from '../constants/addressConstants';

const initialState = {
  localities: [],
  jobAddressDetails: {},
  loading: false,
  smsSent: false
};

export default function Address(state = initialState, action) {

  switch (action.type) {
    case types.GET_JOB_ADDRESS_DETAILS_SUCCCESS:
      return Object.assign({}, state, { jobAddressDetails: action.response, loading: false });
    case types.GET_JOB_ADDRESS_DETAILS_BEGIN:
    case types.UPDATE_JOB_ADDRESS_DETAILS_BEGIN:
      return Object.assign({}, state, { loading: true });
    case types.UPDATE_JOB_ADDRESS_DETAILS_SUCCCESS:
      return Object.assign({}, state, { loading: false, smsSent: action.smsSent });
    case types.GET_LOCALITIES_SUCCESS:
      return Object.assign({}, state, { localities: action.response });
    case types.CLEAR_LOCALITIES:
      return Object.assign({}, state, { localities: [] });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./app/address/reducers/address.js